import { Pipe, PipeTransform } from '@angular/core';
import { DprApprovalStatusSummaryReport } from '@report/models';
import { ApproveStatus } from '@shared/enums/dpr';
import { DprOnlineApproval } from '@shared/models/dpr';

@Pipe({
  name: 'approveStatusColor',
})
export class ApproveStatusColorPipe implements PipeTransform {
  transform(
    data: DprOnlineApproval | DprApprovalStatusSummaryReport,
    property: string
  ): string {
    switch (data?.[property]) {
      case ApproveStatus.Accepted:
        return 'success';
      case ApproveStatus.Rejected:
        return 'danger';
      case ApproveStatus.Seen:
        return 'wip';
      case ApproveStatus.NotApproved:
      default:
        return 'primary';
    }
  }
}
